<template>
  <product-teasers-fi light />
</template>

<script>
import ProductTeasersFi from '@/pages/product-teasers-fi/ProductTeasersFi.vue';

export default {
  name: 'ProductFamilyPreviewFi',
  components: {
    ProductTeasersFi,
  },
  inject: ['fields'],
};
</script>

<style scoped src="./product-family-preview-fi" />

<style src="./product-family-preview-fi-unscoped" />
